import React, { useEffect, useMemo } from 'react';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import './NotFound.css';

export default function NotFound() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = '404 — Levandox';
    // Не индексировать несуществующие адреса
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
    return () => {
      document.title = prevTitle;
      meta.remove();
    };
  }, []);

  // Большой ∄: в шрифте KaTeX нет готового глифа, KaTeX собирает его сам
  const glyph = useMemo(() => katex.renderToString('\\nexists', { throwOnError: false }), []);

  // ∄ p ∈ levandox.com : p = /запрошенный/путь
  const formula = useMemo(() => {
    // В формулу пускаем только безопасные символы пути
    const path = window.location.pathname.replace(/[^A-Za-z0-9/.-]/g, '').slice(0, 40) || '/';
    return katex.renderToString(
      `\\nexists\\, p \\in \\text{levandox.com} : \\; p = \\texttt{${path}}`,
      { throwOnError: false }
    );
  }, []);

  return (
    <main className="nf-page">
      <div className="nf-glyph notranslate" translate="no" aria-hidden="true" dangerouslySetInnerHTML={{ __html: glyph }} />
      <p className="nf-formula notranslate" translate="no" dangerouslySetInnerHTML={{ __html: formula }} />
      <h1 className="nf-title">404 · there exists no such page</h1>
      <a href="/" className="nf-home">
        ← back to levandox
      </a>
    </main>
  );
}
